import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelRadio as _vModelRadio, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f5e0d81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminPosts" }
const _hoisted_2 = { id: "showposts" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--center justify--start" }
const _hoisted_6 = { class: "md2 flex ml-4" }
const _hoisted_7 = {
  class: "md3 flex ml-4",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex" }
const _hoisted_10 = {
  key: 0,
  class: "md2 flex"
}
const _hoisted_11 = { class: "align--center row justify--start mt-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md1 ml-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kolonner:")
], -1))
const _hoisted_13 = {
  class: "flex md10",
  style: {"display":"flex"}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_16 = {
  class: "va-table va-table--striped postsTable",
  style: {"width":"100%"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handlinger", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["id"]
const _hoisted_23 = ["id"]
const _hoisted_24 = ["id"]
const _hoisted_25 = ["id"]
const _hoisted_26 = ["id"]
const _hoisted_27 = ["id"]
const _hoisted_28 = ["id"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_31 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_33 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_34 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_36 = { class: "selectPageSize" }
const _hoisted_37 = { class: "layout gutter--xl" }
const _hoisted_38 = { class: "row justify--center" }
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = { class: "readingSize center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Handlingen kan ikke fortrydes")
  ])
], -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_44 = { class: "editpostmodal" }
const _hoisted_45 = { class: "postType display-4" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "md6 postModal flex" }
const _hoisted_48 = { class: "md2 postModal flex" }
const _hoisted_49 = { class: "md2 postModal flex" }
const _hoisted_50 = { class: "md2 postModal flex" }
const _hoisted_51 = {
  class: "flex md12 mb-4 mt-4",
  style: {"height":"50vh"}
}
const _hoisted_52 = { class: "row justify--center editpostmodal-wrap-buttons" }
const _hoisted_53 = { class: "md3" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_55 = { class: "md3" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_57 = { class: "row align--baseline justify--center mb-2" }
const _hoisted_58 = { class: "md2 flex mr-4" }
const _hoisted_59 = {
  class: "md7 flex",
  style: {"display":"flex"}
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Billedesøgning")
const _hoisted_61 = { class: "md2 flex ml-4" }
const _hoisted_62 = { class: "imageFlexBox" }
const _hoisted_63 = { class: "center imageTitle" }
const _hoisted_64 = { class: "imageBox" }
const _hoisted_65 = ["value"]
const _hoisted_66 = ["src", "title"]
const _hoisted_67 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_69 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_70 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Indsæt billede")
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_73 = { class: "changepostversiondrawer-r" }
const _hoisted_74 = { class: "row justify--space-around align--baseline" }
const _hoisted_75 = { class: "flex" }
const _hoisted_76 = { class: "display-4" }
const _hoisted_77 = { class: "flex" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Titel:"),
  /*#__PURE__*/_createElementVNode("p", null, "Udgivet:"),
  /*#__PURE__*/_createElementVNode("p", null, "Version:")
], -1))
const _hoisted_79 = {
  class: "flex",
  style: {"text-align":"center"}
}
const _hoisted_80 = { class: "flex" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Sæt ")
const _hoisted_82 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_83 = { class: "tabHeight" }
const _hoisted_84 = { id: "newpost" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = {
  key: 1,
  class: "form"
}
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { class: "postform-group" }
const _hoisted_89 = { class: "layout gutter--md indlaeg" }
const _hoisted_90 = { class: "row align--center" }
const _hoisted_91 = { class: "flex md10" }
const _hoisted_92 = { class: "row justify--space-around align--center" }
const _hoisted_93 = { class: "flex md6" }
const _hoisted_94 = { class: "flex md2" }
const _hoisted_95 = { class: "flex md2 align-self--center center" }
const _hoisted_96 = { class: "row justify--space-around" }
const _hoisted_97 = { class: "flex md6" }
const _hoisted_98 = { class: "flex md2" }
const _hoisted_99 = { class: "flex md2" }
const _hoisted_100 = { class: "flex md2" }
const _hoisted_101 = /*#__PURE__*/_createTextVNode("Opret nu")
const _hoisted_102 = { class: "row" }
const _hoisted_103 = { class: "flex md12 mb-4" }
const _hoisted_104 = { class: "row align--baseline justify--center mb-2" }
const _hoisted_105 = { class: "md2 flex mr-4" }
const _hoisted_106 = {
  class: "md7 flex",
  style: {"display":"flex"}
}
const _hoisted_107 = /*#__PURE__*/_createTextVNode("Billedesøgning")
const _hoisted_108 = { class: "md2 flex ml-4" }
const _hoisted_109 = { class: "imageFlexBox" }
const _hoisted_110 = { class: "center imageTitle" }
const _hoisted_111 = { class: "imageBox" }
const _hoisted_112 = ["value"]
const _hoisted_113 = ["src", "title"]
const _hoisted_114 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_116 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_117 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_118 = /*#__PURE__*/_createTextVNode("Indsæt billede")
const _hoisted_119 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_120 = { class: "tabHeight" }
const _hoisted_121 = { class: "kategori-liste" }
const _hoisted_122 = { class: "row justify--start align--baseline" }
const _hoisted_123 = {
  class: "flex md6",
  style: {"text-align":"left"}
}
const _hoisted_124 = /*#__PURE__*/_createTextVNode("category")
const _hoisted_125 = { class: "flex md3" }
const _hoisted_126 = /*#__PURE__*/_createTextVNode("Rediger")
const _hoisted_127 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_128 = {
  class: "row justify--start align--baseline",
  style: {"text-align":"left"}
}
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Beskrivelse:")
], -1))
const _hoisted_130 = { class: "flex md7" }
const _hoisted_131 = { class: "editpostcategorydrawer-r2" }
const _hoisted_132 = { class: "row justify--space-around align--baseline" }
const _hoisted_133 = { class: "flex" }
const _hoisted_134 = { class: "display-4" }
const _hoisted_135 = { class: "flex" }
const _hoisted_136 = { class: "row justify--center align--center" }
const _hoisted_137 = { class: "flex md8 mb-4" }
const _hoisted_138 = { class: "flex md3 mb-4" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","margin-top":"12px","margin-bottom":"7px"} }, "Kategoribeskrivelse", -1))
const _hoisted_141 = {
  class: "flex md12 categoryDrawer",
  style: {"height":"400px"}
}
const _hoisted_142 = { class: "row justify--center" }
const _hoisted_143 = {
  class: "flex editPostCategory",
  style: {"margin-top":"12vh"}
}
const _hoisted_144 = /*#__PURE__*/_createTextVNode("Gem ændringer")
const _hoisted_145 = /*#__PURE__*/_createTextVNode("Gem ændringer og luk")
const _hoisted_146 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "readingSize center" }, "Er du sikker på at du vil slette kategorien?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Handlingen kan ikke fortrydes")
    ])
  ])
], -1))
const _hoisted_148 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_149 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_150 = { class: "tabHeight" }
const _hoisted_151 = { id: "newpostcategory" }
const _hoisted_152 = { key: 0 }
const _hoisted_153 = {
  key: 1,
  class: "kategori-form"
}
const _hoisted_154 = { key: 0 }
const _hoisted_155 = { class: "postcategoryform-group" }
const _hoisted_156 = { class: "layout gutter--xl" }
const _hoisted_157 = { class: "row" }
const _hoisted_158 = { class: "flex md8" }
const _hoisted_159 = { class: "flex md4" }
const _hoisted_160 = { class: "row" }
const _hoisted_161 = {
  class: "flex md12 mb-4",
  style: {"height":"250px","margin-bottom":"20px"}
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","margin-top":"12px","margin-bottom":"7px"} }, "Kategoribeskrivelse", -1))
const _hoisted_163 = {
  class: "row justify--center",
  style: {"margin-top":"60px"}
}
const _hoisted_164 = { class: "flex" }
const _hoisted_165 = /*#__PURE__*/_createTextVNode("Opret nu")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_va_file_upload = _resolveComponent("va-file-upload")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_it_drawer = _resolveComponent("it-drawer")!
  const _component_va_switch = _resolveComponent("va-switch")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger ' + _ctx.stringToLowerCase(_ctx.postTypeTextForm1[_ctx.instanceType]), 'Opret ' + _ctx.stringToLowerCase(_ctx.postTypeTextForm5[_ctx.instanceType]), (_ctx.instanceType!=1 ? 'Vis og rediger kategorier' : ''), (_ctx.instanceType!=1 ? 'Opret ny kategori' : '')], (title) => {
            return (_openBlock(), _createBlock(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.columnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.postSearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findPost()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findPost()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              label: "Udgivelsesstatus",
              modelValue: _ctx.filterStatusStringValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
              options: _ctx.filterStatusStringOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ]),
          (_ctx.instanceType!=1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_va_select, {
                  class: "ml-4",
                  label: "Kategori",
                  modelValue: _ctx.filterPostCategoryStringValue,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterPostCategoryStringValue) = $event)),
                  options: _ctx.filterPostCategoryStringOptions,
                  "text-by": (filterPostCategoryStringOptions) => filterPostCategoryStringOptions.name,
                  "track-by": (filterPostCategoryStringOptions) => filterPostCategoryStringOptions.id,
                  bordered: ""
                }, null, 8, ["modelValue", "options", "text-by", "track-by"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "title",
              label: "Titel"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "author",
              label: "Forfatter"
            }, null, 8, ["modelValue"]),
            (_ctx.instanceType!=1)
              ? (_openBlock(), _createBlock(_component_va_checkbox, {
                  key: 0,
                  modelValue: _ctx.columnName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.columnName) = $event)),
                  "array-value": "category",
                  label: "Kategori"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "published",
              label: "Udgivet"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "updated",
              label: "Opdateret"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "views",
              label: "Visninger"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "version",
              label: "Version"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.columnSort('title')))
                    }, "Titel", 512), [
                      [_vShow, _ctx.showColumn('title')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.columnSort('forfatter')))
                    }, "Forfatter", 512), [
                      [_vShow, _ctx.showColumn('author')]
                    ]),
                    (_ctx.instanceType!=1)
                      ? _withDirectives((_openBlock(), _createElementBlock("th", {
                          key: 0,
                          class: "sorting",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.columnSort('kategori')))
                        }, "Kategori", 512)), [
                          [_vShow, _ctx.showColumn('category')]
                        ])
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.columnSort('udgivet')))
                    }, "Udgivet den", 512), [
                      [_vShow, _ctx.showColumn('published')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.columnSort('opdateret')))
                    }, "Sidst opdateret", 512), [
                      [_vShow, _ctx.showColumn('updated')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.columnSort('visninger')))
                    }, "Antal visninger", 512), [
                      [_vShow, _ctx.showColumn('views')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.columnSort('version')))
                    }, "Version", 512), [
                      [_vShow, _ctx.showColumn('version')]
                    ]),
                    _hoisted_18
                  ])
                ]),
                _hoisted_19,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPostsOfType(_ctx.instanceType), (indlaeg, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: indlaeg.id
                  }, [
                    _createElementVNode("td", {
                      id: 'poststable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(indlaeg.id), 9, _hoisted_20),
                    _withDirectives(_createElementVNode("td", {
                      id: 'poststable-row' + (index+1)
                    }, _toDisplayString(indlaeg.indlaeg_versionerings_id?.[_ctx.getIndexOfPostVersion(indlaeg?.indlaeg_version, indlaeg)]?.indlaeg_versionering_titel), 9, _hoisted_21), [
                      [_vShow, _ctx.showColumn('title')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'poststable-row' + (index+1)
                    }, _toDisplayString(indlaeg?.indlaeg_forfatter?.username), 9, _hoisted_22), [
                      [_vShow, _ctx.showColumn('author')]
                    ]),
                    (_ctx.instanceType!=1)
                      ? _withDirectives((_openBlock(), _createElementBlock("td", {
                          key: 0,
                          id: 'poststable-row' + (index+1)
                        }, _toDisplayString(indlaeg?.indlaeg_kategori_id?.indlaeg_kategori_titel), 9, _hoisted_23)), [
                          [_vShow, _ctx.showColumn('category')]
                        ])
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("td", {
                      id: 'poststable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(_ctx.postDateFormatter(indlaeg.indlaeg_udgivet)), 9, _hoisted_24), [
                      [_vShow, _ctx.showColumn('published')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'poststable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(_ctx.postDateFormatter(indlaeg.updated_at)), 9, _hoisted_25), [
                      [_vShow, _ctx.showColumn('updated')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'poststable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(indlaeg.indlaeg_visninger), 9, _hoisted_26), [
                      [_vShow, _ctx.showColumn('views')]
                    ]),
                    _withDirectives(_createElementVNode("td", {
                      id: 'poststable-row' + (index+1),
                      class: "center"
                    }, [
                      _createVNode(_component_va_button, {
                        class: "btn",
                        name: "changepostverion",
                        onClick: ($event: any) => (_ctx.changePostVersion(indlaeg.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString('Version: ' + indlaeg.indlaeg_version), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 8, _hoisted_27), [
                      [_vShow, _ctx.showColumn('version')]
                    ]),
                    _createElementVNode("td", {
                      id: 'poststable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            color: "info",
                            class: "btn",
                            name: "editpost",
                            onClick: ($event: any) => (_ctx.editPost(indlaeg.id, indlaeg.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            icon: indlaeg.indlaeg_status ? 'check_box' : 'check_box_outline_blank',
                            color: indlaeg.indlaeg_status ? 'success' : 'rgb(255, 172, 10)',
                            class: "btn status-width",
                            name: "statuspost",
                            onClick: ($event: any) => (_ctx.statusPost(indlaeg.id, indlaeg.documentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(indlaeg.indlaeg_status ? 'Udgivet' : 'Kladde'), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "color", "onClick"]),
                          _createVNode(_component_va_button, {
                            color: "danger",
                            class: "btn",
                            name: "delepost",
                            onClick: ($event: any) => (_ctx.deletePostWarning(indlaeg.id, indlaeg.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_28)
                  ]))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_32,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.currentPage) = $event)),
            type: "number",
            onKeyup: _cache[25] || (_cache[25] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_33, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_34, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
          }),
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteWarningModal,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.deleteWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.deletePost(this.deletePostId, this.deletePostDocumentId), _ctx.$Message.success({ text: _ctx.postTypeTextForm4[_ctx.instanceType] + ' er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.deleteWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_43
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("p", _hoisted_40, "Er du sikker på at du vil slette " + _toDisplayString(_ctx.stringToLowerCase(_ctx.postTypeTextForm4[_ctx.instanceType])), 1)
                ])
              ]),
              _hoisted_41
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_modal, {
          modelValue: _ctx.editPostModal,
          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.editPostModal) = $event)),
          width: "85%",
          "closable-mask": false
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("h4", _hoisted_45, "Rediger " + _toDisplayString(_ctx.stringToLowerCase(_ctx.postTypeTextForm4[_ctx.instanceType])), 1),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_va_input, {
                    class: "mb-2",
                    label: 'Titlen på ' + _ctx.stringToLowerCase(_ctx.postTypeTextForm4[_ctx.instanceType]),
                    type: "text",
                    placeholder: "Titel",
                    modelValue: _ctx.postData.postTitle,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.postData.postTitle) = $event)),
                    id: "editpostmodal-indlaeg_versionering_titel",
                    bordered: ""
                  }, {
                    prependInner: _withCtx(() => [
                      _createVNode(_component_va_icon, { name: "title" })
                    ]),
                    _: 1
                  }, 8, ["label", "modelValue"]),
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.postData.postSlug,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.postData.postSlug) = $event)),
                    type: "text",
                    label: "slug",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  (_ctx.instanceType!=1)
                    ? (_openBlock(), _createBlock(_component_va_select, {
                        key: 0,
                        label: "Kategori",
                        modelValue: _ctx.postCategoryTitleValue,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.postCategoryTitleValue) = $event)),
                        options: _ctx.postCategoryTitleOptions,
                        bordered: "",
                        "text-by": "name"
                      }, null, 8, ["modelValue", "options"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_va_input, {
                    class: "center",
                    label: "Udgivelsesdato",
                    type: "date",
                    placeholder: "Dato",
                    modelValue: _ctx.postData.postReleasedDate,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.postData.postReleasedDate) = $event)),
                    bordered: ""
                  }, {
                    prependInner: _withCtx(() => [
                      _createVNode(_component_va_icon, { name: "pending_actions" })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_va_input, {
                    class: "center",
                    label: "Udgivelsestid",
                    type: "time",
                    placeholder: "Tid",
                    modelValue: _ctx.postData.postReleasedTime,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.postData.postReleasedTime) = $event)),
                    bordered: ""
                  }, {
                    prependInner: _withCtx(() => [
                      _createVNode(_component_va_icon, { name: "pending_actions" })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_quill_editor, {
                  ref: "editPostEditor",
                  options: _ctx.quillToolbar,
                  contentType: "html",
                  content: _ctx.postData.postContents,
                  "onUpdate:content": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.postData.postContents) = $event)),
                  theme: "snow",
                  class: "quillEditor"
                }, null, 8, ["options", "content"])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-4",
                    onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.updatePost() ? _ctx.$Message.success({ text: 'Gemt succesfuldt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' }))),
                    color: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_54
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-4",
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editPostModal = false), _ctx.cancelPostEdit())),
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_56
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_va_modal, {
              modelValue: _ctx.editPostImageModal,
              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.editPostImageModal) = $event)),
              title: "Vælg billede",
              size: "large",
              "hide-default-actions": "",
              "overlay-opacity": "0.5"
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_va_button, {
                  color: "success",
                  onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.insertImage()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_71
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "ml-4",
                  color: "secondary",
                  onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.editPostImageModal = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_72
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_va_button, {
                      class: "btn",
                      rounded: false,
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.resetSearch()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_icon, {
                          class: "reset",
                          name: "autorenew"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_va_input, {
                      modelValue: _ctx.imageSearchInputValue,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.imageSearchInputValue) = $event)),
                      label: "Søg",
                      onKeyup: _cache[43] || (_cache[43] = _withKeys(($event: any) => (_ctx.findImage()), ["enter"]))
                    }, {
                      prependInner: _withCtx(() => [
                        _createVNode(_component_va_icon, { name: "image_search" })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_va_button, {
                      size: "small",
                      class: "btn ml-2",
                      rounded: false,
                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.findImage()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_icon, { name: "search" }),
                        _hoisted_60
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_va_file_upload, {
                      color: "success",
                      size: "small",
                      modelValue: _ctx.imageUpload,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.imageUpload) = $event)),
                      type: "single",
                      "file-types": ".jpg,.jpeg,.png"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_it_divider),
                _createElementVNode("div", _hoisted_62, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageFiles, (image) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "imageContainer",
                      key: image.id
                    }, [
                      _createElementVNode("p", _hoisted_63, _toDisplayString((image.name).slice(0, 10) + '...'), 1),
                      _createElementVNode("label", _hoisted_64, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.selectedImage) = $event)),
                          class: "postImageRadio",
                          type: "radio",
                          name: "choosenImage",
                          value: image
                        }, null, 8, _hoisted_65), [
                          [_vModelRadio, _ctx.selectedImage]
                        ]),
                        _createElementVNode("img", {
                          src: _ctx.getImage(image),
                          class: "imagessize",
                          title: image.name
                        }, null, 8, _hoisted_66)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_va_button, {
                    icon: "first_page",
                    class: "mr-2",
                    size: "small",
                    rounded: false,
                    onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.jumpToImagePage(1)))
                  }),
                  _createVNode(_component_va_button, {
                    icon: "keyboard_double_arrow_left",
                    class: "mr-2",
                    size: "small",
                    rounded: false,
                    onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.turnToNewImagePage(-5)))
                  }),
                  _createVNode(_component_va_button, {
                    icon: "chevron_left",
                    class: "mr-2",
                    size: "small",
                    rounded: false,
                    onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.turnToNewImagePage(-1)))
                  }),
                  _hoisted_68,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.currentImagePage) = $event)),
                    onKeyup: _cache[51] || (_cache[51] = _withKeys(($event: any) => (_ctx.jumpToImagePage(this.currentImagePage)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.currentImagePage]
                  ]),
                  (_ctx.totalNumberOfImagePages === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_69, " af " + _toDisplayString(_ctx.totalNumberOfImagePages+1), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_70, " af " + _toDisplayString(_ctx.totalNumberOfImagePages), 1)),
                  _createVNode(_component_va_button, {
                    icon: "chevron_right",
                    class: "mr-2",
                    size: "small",
                    rounded: false,
                    onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.turnToNewImagePage(1)))
                  }),
                  _createVNode(_component_va_button, {
                    icon: "keyboard_double_arrow_right",
                    class: "mr-2",
                    size: "small",
                    rounded: false,
                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.turnToNewImagePage(5)))
                  }),
                  _createVNode(_component_va_button, {
                    icon: "last_page",
                    class: "mr-2",
                    size: "small",
                    rounded: false,
                    onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.jumpToImagePage(this.totalNumberOfImagePages)))
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_drawer, {
          modelValue: _ctx.changePostVersionNestedDrawerR,
          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.changePostVersionNestedDrawerR) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("h4", _hoisted_76, "Versionering af " + _toDisplayString(_ctx.stringToLowerCase(_ctx.postTypeTextForm4[_ctx.instanceType])), 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createVNode(_component_va_icon, {
                    name: "history",
                    size: "4rem",
                    color: "#b4003a"
                  })
                ])
              ])
            ]),
            _createVNode(_component_it_divider),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indlaegversionerings, (indlaegversionering) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: indlaegversionering.id
              }, [
                _createElementVNode("div", {
                  class: "row justify--space-around align--center",
                  style: _normalizeStyle(indlaegversionering.indlaeg_versionering_version === _ctx.lastChangedPostVersionCurrentVersion ? 'font-weight:bold;' : 'font-weight:normal;')
                }, [
                  _hoisted_78,
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("p", null, _toDisplayString(indlaegversionering.indlaeg_versionering_titel), 1),
                    _createElementVNode("p", null, _toDisplayString((new Date(indlaegversionering.published_at)).toLocaleDateString('da-DK')), 1),
                    _createElementVNode("p", null, _toDisplayString(indlaegversionering.indlaeg_versionering_version), 1)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createVNode(_component_va_button_group, { rounded: false }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_button, {
                          color: indlaegversionering.indlaeg_versionering_version === _ctx.lastChangedPostVersionCurrentVersion ? 'success' : 'secondary',
                          icon: indlaegversionering.indlaeg_versionering_version === _ctx.lastChangedPostVersionCurrentVersion ? 'check_box' : 'check_box_outline_blank',
                          onClick: ($event: any) => (_ctx.changeToPostVersion(indlaegversionering.id, indlaegversionering.indlaeg_versionering_version))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_81
                          ]),
                          _: 2
                        }, 1032, ["color", "icon", "onClick"]),
                        _createVNode(_component_va_button, {
                          color: "danger",
                          onClick: ($event: any) => (_ctx.deletePostVersion(indlaegversionering.id, indlaegversionering.indlaeg_versionering_version))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_82
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 4),
                _createVNode(_component_it_divider)
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger ' + _ctx.stringToLowerCase(_ctx.postTypeTextForm1[_ctx.instanceType])]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_83, [
        _createElementVNode("div", _hoisted_84, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("form", {
                          id: "newpostform",
                          onSubmit: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
                        }, [
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("div", _hoisted_92, [
                                  _createElementVNode("div", _hoisted_93, [
                                    _createVNode(_component_va_input, {
                                      id: "indlaeg_titel",
                                      modelValue: _ctx.postData.postTitle,
                                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.postData.postTitle) = $event)),
                                      type: "text",
                                      name: "indlaeg_titel",
                                      placeholder: "Titel",
                                      label: 'Titlen på ' + _ctx.stringToLowerCase(_ctx.postTypeTextForm4[_ctx.instanceType]),
                                      bordered: "",
                                      rules: [(postTitle) => _ctx.postData.postTitle.length > 1 || 'Der mangler en titel']
                                    }, null, 8, ["modelValue", "label", "rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_94, [
                                    (_ctx.instanceType!=1)
                                      ? (_openBlock(), _createBlock(_component_va_select, {
                                          key: 0,
                                          label: "Kategori",
                                          modelValue: _ctx.postCategoryTitleValue,
                                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.postCategoryTitleValue) = $event)),
                                          options: _ctx.postCategoryTitleOptions,
                                          "text-by": "name",
                                          bordered: ""
                                        }, null, 8, ["modelValue", "options"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_95, [
                                    _createVNode(_component_va_switch, {
                                      modelValue: _ctx.postData.postStatus,
                                      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.postData.postStatus) = $event)),
                                      name: "indlaeg_status",
                                      color: "success",
                                      label: 'Status: ' + (_ctx.postData.postStatus ? 'Udgivet' : 'Kladde')
                                    }, null, 8, ["modelValue", "label"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_96, [
                                  _createElementVNode("div", _hoisted_97, [
                                    _createVNode(_component_va_input, {
                                      label: "slug",
                                      modelValue: _ctx.postData.postSlug,
                                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.postData.postSlug) = $event)),
                                      placeholder: _ctx.convertToSlug(_ctx.postData.postTitle),
                                      bordered: ""
                                    }, null, 8, ["modelValue", "placeholder"])
                                  ]),
                                  _createElementVNode("div", _hoisted_98, [
                                    _createVNode(_component_va_input, {
                                      class: "center",
                                      type: "date",
                                      label: "Udgivelsesdato",
                                      placeholder: "Dato",
                                      modelValue: _ctx.postData.postReleasedDate,
                                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.postData.postReleasedDate) = $event)),
                                      bordered: ""
                                    }, {
                                      prependInner: _withCtx(() => [
                                        _createVNode(_component_va_icon, { name: "pending_actions" })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_99, [
                                    _createVNode(_component_va_input, {
                                      class: "center",
                                      type: "time",
                                      label: "Udgivelsestid",
                                      placeholder: "Tid",
                                      modelValue: _ctx.postData.postReleasedTime,
                                      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.postData.postReleasedTime) = $event)),
                                      bordered: ""
                                    }, {
                                      prependInner: _withCtx(() => [
                                        _createVNode(_component_va_icon, { name: "pending_actions" })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_100, [
                                _createVNode(_component_va_button, {
                                  class: "btn",
                                  color: "success",
                                  size: "large",
                                  onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.createPost()))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_101
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("div", _hoisted_103, [
                                _createVNode(_component_quill_editor, {
                                  ref: "createPostEditor",
                                  options: _ctx.quillToolbar,
                                  contentType: "html",
                                  content: _ctx.postData.postContents,
                                  "onUpdate:content": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.postData.postContents) = $event)),
                                  theme: "snow",
                                  style: {"height":"500px"}
                                }, null, 8, ["options", "content"])
                              ])
                            ])
                          ])
                        ], 32)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.createPostImageModal,
          "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.createPostImageModal) = $event)),
          title: "Vælg billede",
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              color: "success",
              onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.insertImage()))
            }, {
              default: _withCtx(() => [
                _hoisted_118
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.createPostImageModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_119
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.resetSearch()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_106, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.imageSearchInputValue,
                  "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.imageSearchInputValue) = $event)),
                  label: "Søg",
                  onKeyup: _cache[71] || (_cache[71] = _withKeys(($event: any) => (_ctx.findImage()), ["enter"]))
                }, {
                  prependInner: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "image_search" })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_va_button, {
                  size: "small",
                  class: "btn ml-2",
                  rounded: false,
                  onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.findImage()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "search" }),
                    _hoisted_107
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_108, [
                _createVNode(_component_va_file_upload, {
                  color: "success",
                  size: "small",
                  modelValue: _ctx.imageUpload,
                  "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.imageUpload) = $event)),
                  type: "single",
                  "file-types": ".jpg,.jpeg,.png"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode(_component_it_divider),
            _createElementVNode("div", _hoisted_109, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageFiles, (image) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "imageContainer",
                  key: image.id
                }, [
                  _createElementVNode("p", _hoisted_110, _toDisplayString((image.name).slice(0, 10) + '...'), 1),
                  _createElementVNode("label", _hoisted_111, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.selectedImage) = $event)),
                      class: "postImageRadio",
                      type: "radio",
                      name: "choosenImage",
                      value: image
                    }, null, 8, _hoisted_112), [
                      [_vModelRadio, _ctx.selectedImage]
                    ]),
                    _createElementVNode("img", {
                      src: _ctx.getImage(image),
                      class: "imagessize",
                      title: image.name
                    }, null, 8, _hoisted_113)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_114, [
              _createVNode(_component_va_button, {
                icon: "first_page",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.jumpToImagePage(1)))
              }),
              _createVNode(_component_va_button, {
                icon: "keyboard_double_arrow_left",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.turnToNewImagePage(-5)))
              }),
              _createVNode(_component_va_button, {
                icon: "chevron_left",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.turnToNewImagePage(-1)))
              }),
              _hoisted_115,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.currentImagePage) = $event)),
                onKeyup: _cache[79] || (_cache[79] = _withKeys(($event: any) => (_ctx.jumpToImagePage(this.currentImagePage)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.currentImagePage]
              ]),
              (_ctx.totalNumberOfImagePages === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_116, " af " + _toDisplayString(_ctx.totalNumberOfImagePages+1), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_117, " af " + _toDisplayString(_ctx.totalNumberOfImagePages), 1)),
              _createVNode(_component_va_button, {
                icon: "chevron_right",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.turnToNewImagePage(1)))
              }),
              _createVNode(_component_va_button, {
                icon: "keyboard_double_arrow_right",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.turnToNewImagePage(5)))
              }),
              _createVNode(_component_va_button, {
                icon: "last_page",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.jumpToImagePage(this.totalNumberOfImagePages)))
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret ' + _ctx.stringToLowerCase(_ctx.postTypeTextForm5[_ctx.instanceType])]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_120, [
        _createElementVNode("div", _hoisted_121, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indlaegkategoris, (indlaegkategori, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "layout gutter--xl enkelt-kategori",
              key: indlaegkategori.id
            }, [
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_va_icon, {
                      class: "material-icons mr-2",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_124
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(index+1) + ". " + _toDisplayString(indlaegkategori?.indlaeg_kategori_titel), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_125, [
                  _createVNode(_component_va_button_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_button, {
                        class: "btn",
                        color: "primary",
                        onClick: ($event: any) => (_ctx.editPostCategory(indlaegkategori.id, indlaegkategori.documentId))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_126
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_va_button, {
                        icon: indlaegkategori.indlaeg_kategori_status ? 'check_box' : 'check_box_outline_blank',
                        class: "btn",
                        color: indlaegkategori.indlaeg_kategori_status ? 'success' : 'rgb(255, 172, 10)',
                        onClick: ($event: any) => (_ctx.statusPostCategory(indlaegkategori.id, indlaegkategori.documentId))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(indlaegkategori.indlaeg_kategori_status ? 'Aktiv' : 'Inaktiv'), 1)
                        ]),
                        _: 2
                      }, 1032, ["icon", "color", "onClick"]),
                      (indlaegkategori.id > 2)
                        ? (_openBlock(), _createBlock(_component_va_button, {
                            key: 0,
                            class: "btn",
                            color: "danger",
                            onClick: ($event: any) => (_ctx.deletePostCategoryWarning(indlaegkategori.id, indlaegkategori.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_127
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _createElementVNode("div", _hoisted_128, [
                _hoisted_129,
                _createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.convertHTMLToTextShort(indlaegkategori.indlaeg_kategori_beskrivelse)), 1)
              ])
            ]))
          }), 128))
        ]),
        _createVNode(_component_it_drawer, {
          modelValue: _ctx.editPostCategoryNestedDrawerR2,
          "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.editPostCategoryNestedDrawerR2) = $event)),
          width: "33%"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("h4", _hoisted_134, "Rediger " + _toDisplayString(_ctx.stringToLowerCase(_ctx.postTypeTextForm4[_ctx.instanceType])) + "s kategori", 1)
                ]),
                _createElementVNode("div", _hoisted_135, [
                  _createVNode(_component_va_icon, {
                    name: "category",
                    size: "4rem",
                    color: "#b4003a"
                  })
                ])
              ])
            ]),
            _createVNode(_component_it_divider),
            _createElementVNode("div", _hoisted_136, [
              _createElementVNode("div", _hoisted_137, [
                _createVNode(_component_va_input, {
                  class: "categoryDrawer",
                  modelValue: _ctx.postCategoryData.postCategoryTitle,
                  "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.postCategoryData.postCategoryTitle) = $event)),
                  type: "text",
                  label: 'Kategorinavn for ' + _ctx.stringToLowerCase(_ctx.postTypeTextForm2[_ctx.instanceType]),
                  placeholder: "Navn",
                  bordered: ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _createElementVNode("div", _hoisted_138, [
                _createVNode(_component_va_checkbox, {
                  color: "success",
                  modelValue: _ctx.postCategoryData.postCategoryStatus,
                  "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.postCategoryData.postCategoryStatus) = $event)),
                  label: "Aktiver"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_139, [
              _hoisted_140,
              _createElementVNode("div", _hoisted_141, [
                _createVNode(_component_quill_editor, {
                  ref: "editPostCategoryEditor",
                  toolbar: "full",
                  contentType: "html",
                  content: _ctx.postCategoryData.postCategoryDescription,
                  "onUpdate:content": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.postCategoryData.postCategoryDescription) = $event)),
                  theme: "snow"
                }, null, 8, ["content"])
              ])
            ]),
            _createElementVNode("div", _hoisted_142, [
              _createElementVNode("div", _hoisted_143, [
                _createVNode(_component_va_button, {
                  class: "btn",
                  color: "success",
                  onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.updateCategoryPost(0)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_144
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "btn",
                  color: "success",
                  onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.updateCategoryPost(1)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_145
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "btn",
                  color: "success",
                  onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.editPostCategoryNestedDrawerR2 = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_146
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteCategoryWarningModal,
          "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.deleteCategoryWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.deletePostCategory(this.deleteCategoryPostId, this.deleteCategoryPostDocumentId), _ctx.$Message.success({ text: 'Kategorien er blevet slettet'})))
            }, {
              default: _withCtx(() => [
                _hoisted_148
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.deleteCategoryWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_149
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_147
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger kategorier']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_150, [
        _createElementVNode("div", _hoisted_151, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_153, [
                (!_ctx.submitted2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                      _createElementVNode("div", _hoisted_155, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newpostcategoryform",
                          onSubmit: _ctx.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_156, [
                              _createElementVNode("div", _hoisted_157, [
                                _createElementVNode("div", _hoisted_158, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.postCategoryData.postCategoryTitle,
                                    "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.postCategoryData.postCategoryTitle) = $event)),
                                    label: "Kategorinavn",
                                    rules: [(postCategoryTitle) => _ctx.postCategoryData.postCategoryTitle.length > 1 || 'Kategorien skal have et navn'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_159, [
                                  _createVNode(_component_va_switch, {
                                    class: "mb-4 mr-4",
                                    color: "success",
                                    modelValue: _ctx.postCategoryData.postCategoryStatus,
                                    "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.postCategoryData.postCategoryStatus) = $event)),
                                    label: 'Status: ' + (_ctx.postCategoryData.postCategoryStatus ? 'Aktiv' : 'Inaktiv')
                                  }, null, 8, ["modelValue", "label"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_160, [
                                _createElementVNode("div", _hoisted_161, [
                                  _hoisted_162,
                                  _createVNode(_component_quill_editor, {
                                    toolbar: "full",
                                    contentType: "html",
                                    content: _ctx.postCategoryData.postCategoryDescription,
                                    "onUpdate:content": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.postCategoryData.postCategoryDescription) = $event)),
                                    theme: "snow"
                                  }, null, 8, ["content"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_163, [
                        _createElementVNode("div", _hoisted_164, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            size: "large",
                            color: "success",
                            onClick: _cache[99] || (_cache[99] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createPostCategory()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_165
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret ny kategori']
      ])
    ])
  ]))
}